import _classCallCheck from "/home/maticz_developer_04/Documents/A_Projects/BellExchange/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/maticz_developer_04/Documents/A_Projects/BellExchange/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/maticz_developer_04/Documents/A_Projects/BellExchange/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/maticz_developer_04/Documents/A_Projects/BellExchange/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/maticz_developer_04/Documents/A_Projects/BellExchange/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Observable from 'zen-observable';
import { Component } from 'react';
import PropTypes from 'prop-types';
var minuteSeconds = 60;
var hourSeconds = minuteSeconds * 60;
var daySeconds = hourSeconds * 24;
export function formatDate(date, now) {
  var d = now - date;
  if (d < minuteSeconds * 2) {
    return {
      value: "now",
      next: minuteSeconds * 2 - d
    };
  } else if (d < hourSeconds) {
    var minutes = Math.floor(d / minuteSeconds);
    return {
      value: "".concat(minutes, "m ago"),
      next: minuteSeconds - d % 60
    };
  } else if (d < daySeconds) {
    var hours = Math.floor(d / hourSeconds);
    return {
      value: "".concat(hours, "h ago"),
      next: hourSeconds - d % hourSeconds
    };
  } else {
    var days = Math.floor(d / daySeconds);
    return {
      value: "".concat(days, "d ago"),
      next: daySeconds - d % daySeconds
    };
  }
}
export function createTimeAgoObservable() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var _formatDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : formatDate;
  return new Observable(function (observer) {
    var pendingTimeout = undefined;
    var initial = date.getTime() / 1000;
    function update() {
      var now = new Date().getTime() / 1000;
      var _formatDate2 = _formatDate(initial, now),
        value = _formatDate2.value,
        next = _formatDate2.next;
      observer.next(value);
      pendingTimeout = setTimeout(update, next * 1000);
    }
    update();
    return function () {
      if (pendingTimeout === undefined) return;
      clearTimeout(pendingTimeout);
    };
  });
}
export var TimeAgo = /*#__PURE__*/function (_Component) {
  _inherits(TimeAgo, _Component);
  var _super = _createSuper(TimeAgo);
  function TimeAgo() {
    var _this;
    _classCallCheck(this, TimeAgo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    var _assertThisInitialize = _assertThisInitialized(_this),
      _assertThisInitialize2 = _assertThisInitialize.props,
      formatter = _assertThisInitialize2.formatter,
      date = _assertThisInitialize2.date;
    var _formatter = formatter(date.getTime() / 1000, new Date().getTime() / 1000),
      value = _formatter.value;
    _this.state = {
      error: undefined,
      value: value
    };
    _this.subscription = undefined;
    return _this;
  }
  _createClass(TimeAgo, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;
      var _this$props = this.props,
        date = _this$props.date,
        formatter = _this$props.formatter;
      this.subscription = createTimeAgoObservable(date, formatter).subscribe({
        next: function next(value) {
          if (value === _this2.state.value) {
            return;
          }
          _this2.setState({
            value: value
          });
        },
        error: function error(_error) {
          return _this2.setState({
            error: _error,
            value: undefined
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.subscription) {
        return;
      }
      this.subscription.unsubscribe();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;
      if (this.props.date.getTime() !== nextProps.date.getTime()) {
        this.subscription.unsubscribe();
        var _this$props$formatter = this.props.formatter(nextProps.date.getTime() / 1000, new Date().getTime() / 1000),
          value = _this$props$formatter.value;
        this.setState({
          value: value
        });
        this.subscription = createTimeAgoObservable(nextProps.date, this.props.formatter).subscribe({
          next: function next(value) {
            if (value === _this3.state.value) {
              return;
            }
            _this3.setState({
              value: value
            });
          },
          error: function error(_error2) {
            return _this3.setState({
              error: _error2,
              value: undefined
            });
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        error = _this$state.error,
        value = _this$state.value,
        _this$props2 = this.props,
        render = _this$props2.render,
        children = _this$props2.children;
      return (children || render)({
        error: error,
        value: value
      });
    }
  }]);
  return TimeAgo;
}(Component);
TimeAgo.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  render: PropTypes.func,
  formatter: PropTypes.func
};
TimeAgo.defaultProps = {
  formatter: formatDate
};